import mira from "../../assets/img/mira.jpg";
import omar from "../../assets/img/omar.jpg";
import emre from "../../assets/img/emre.jpg";
import yaman from "../../assets/img/yaman.jpg";
import burak from "../../assets/img/burak.png";

export const TEAM_DATA = [
  {
    name: "Omar Alithawi",
    image: omar,
  },

  {
    name: "Burak Selvi",
    image: burak,
  },

  {
    name: "Mira Arar",
    image: mira,
  },

  {
    name: "Emre Erdem",
    image: emre,
  },

  {
    name: "Yaman Kahveci",
    image: yaman,
  },
];
